"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ResetPassword = ResetPassword;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = __importDefault(require("react"));
const react_intl_1 = require("react-intl");
const antd_1 = require("antd");
const elements_1 = require("@src/components/elements");
const ResetPasswordForm_1 = require("./ResetPasswordForm");
function ResetPassword() {
    return ((0, jsx_runtime_1.jsxs)(elements_1.Holder, { marginVertical: true, children: [(0, jsx_runtime_1.jsx)(antd_1.Row, { justify: "center", children: (0, jsx_runtime_1.jsx)(antd_1.Col, { children: (0, jsx_runtime_1.jsx)(elements_1.Title, { level: 1, type: "secondary", children: (0, jsx_runtime_1.jsx)(react_intl_1.FormattedMessage, { id: "reset_password.password_recovery" }) }) }) }), (0, jsx_runtime_1.jsx)(antd_1.Row, { justify: "center", children: (0, jsx_runtime_1.jsx)(antd_1.Col, { xs: 24, md: 18, lg: 12, children: (0, jsx_runtime_1.jsx)(elements_1.Panel, { children: (0, jsx_runtime_1.jsx)(ResetPasswordForm_1.ResetPasswordForm, {}) }) }) })] }));
}
